import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/main.scss'; 
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';
import './i18n.js';
import 'html5-device-mockups/dist/device-mockups.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
